import {
  Information_Detail_CollectRentalFee,
  Information_Detail_PaymentRentalFee,
  MessageSchema,
} from '@victgame/akiverse-backend/dist/event_message'
import { NotificationsQuery } from '../query.generated'
import { t } from 'i18next'
import { formatDate } from '@/src/utils/DateUtils'

export const getTitleAndDetails = ({
  messageJson,
  messageDetailJson,
}: NotificationsQuery['currentUserNotifications'][number]): { title: string; details?: Array<string> } => {
  const notification = MessageSchema.parse(messageJson)
  switch (notification.messageId) {
    case 'A00001': {
      return { title: t(`Notifications.${notification.messageId}`) }
    }
    case 'A00002': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          // 序数にする
          totalMegaSpark: t('ordinal', { count: notification.totalMegaSpark, ordinal: true }),
        }),
      }
    }
    case 'A00003': {
      return {
        title: t(`Notifications.${notification.messageId}`),
      }
    }
    case 'A00004': {
      return {
        title: t(`Notifications.${notification.messageId}`),
      }
    }
    case 'I00001': {
      return { title: t(`Notifications.${notification.messageId}`, { gcId: notification.gameCenterId }) }
    }
    case 'I00002': {
      return { title: t(`Notifications.${notification.messageId}`, { gcId: notification.gameCenterId }) }
    }
    case 'I00003': {
      return { title: t(`Notifications.${notification.messageId}`, { gcId: notification.gameCenterId }) }
    }
    case 'I00004': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          gcId: notification.gameCenterId,
          date: formatDate(notification.stopRentingDate, 'YYYY.MM.DD'),
        }),
      }
    }
    case 'I00005': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          gcId: notification.gameCenterId,
          date: formatDate(notification.stopRentingDate, 'YYYY.MM.DD'),
        }),
      }
    }
    case 'I00006': {
      return { title: t(`Notifications.${notification.messageId}`, { gcId: notification.gameCenterId }) }
    }
    case 'I00008': {
      return { title: t(`Notifications.${notification.messageId}`, { amId: notification.arcadeMachineId }) }
    }
    case 'I00009': {
      return { title: t(`Notifications.${notification.messageId}`, { amId: notification.arcadeMachineId }) }
    }
    case 'I00010': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          gcId: notification.gameCenterId,
          amId: notification.arcadeMachineId,
        }),
      }
    }
    case 'I00011': {
      return { title: t(`Notifications.${notification.messageId}`, { gcId: notification.gameCenterId }) }
    }
    case 'I00012': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          gcId: notification.gameCenterId,
          amId: notification.arcadeMachineId,
        }),
      }
    }
    case 'I00013': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          gcId: notification.gameCenterId,
          amId: notification.arcadeMachineId,
        }),
      }
    }
    case 'I00014': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          gcId: notification.gameCenterId,
          amId: notification.arcadeMachineId,
        }),
      }
    }
    case 'I00015': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          gcId: notification.gameCenterId,
          amId: notification.arcadeMachineId,
        }),
      }
    }
    case 'I00016': {
      return { title: t(`Notifications.${notification.messageId}`, { gcId: notification.gameCenterId }) }
    }
    case 'I00017': {
      return { title: t(`Notifications.${notification.messageId}`, { gcId: notification.gameCenterId }) }
    }
    case 'I00018': {
      return { title: t(`Notifications.${notification.messageId}`, { gcId: notification.gameCenterId }) }
    }
    case 'I00019': {
      return { title: t(`Notifications.${notification.messageId}`, { apName: notification.name }) }
    }
    case 'I00020': {
      return { title: t(`Notifications.${notification.messageId}`, { apName: notification.name }) }
    }
    case 'I00021': {
      return {
        title: t(`Notifications.${notification.messageId}`, { craftId: notification.arcadeMachineId }),
      }
    }
    case 'I00022': {
      const { details } = Information_Detail_PaymentRentalFee.parse(messageDetailJson)
      return {
        title: t(`Notifications.${notification.messageId}`, {
          num: notification.inOperationGcCount.toLocaleString(),
          renewCount: notification.renewCount.toLocaleString(),
          uninstallCount: notification.uninstallCount.toLocaleString(),
        }),
        details: details.map((d) => {
          switch (d.messageId) {
            case 'I00022-success':
              return t(`Notifications.${d.messageId}`, {
                fee: d.fee.toLocaleString(),
                amId: d.arcadeMachineId,
              })
            case 'I00022-fail':
              return t(`Notifications.${d.messageId}`, { amId: d.arcadeMachineId })
            default: {
              const n: never = d
              return JSON.stringify(n)
            }
          }
        }),
      }
    }
    case 'I00023': {
      const { details } = Information_Detail_CollectRentalFee.parse(messageDetailJson)
      return {
        title: t(`Notifications.${notification.messageId}`, {
          num: notification.installedCount.toLocaleString(),
          renewCount: notification.renewCount.toLocaleString(),
          uninstallCount: notification.uninstallCount.toLocaleString(),
        }),
        details: details.map((d) => {
          switch (d.messageId) {
            case 'I00023-success':
              return t(`Notifications.${d.messageId}`, {
                fee: d.fee.toLocaleString(),
                amId: d.arcadeMachineId,
              })
            case 'I00023-fail':
              return t(`Notifications.${d.messageId}`, { amId: d.arcadeMachineId })
            default: {
              const n: never = d
              return JSON.stringify(n)
            }
          }
        }),
      }
    }
    case 'I00024': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          arcadeMachineId: notification.arcadeMachineId,
        }),
      }
    }
    case 'I00025': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          arcadeMachineId: notification.arcadeMachineId,
        }),
      }
    }
    case 'I00026': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          gameCenterId: notification.gameCenterId,
        }),
      }
    }
    case 'I00027': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          arcadeMachineId: notification.arcadeMachineId,
        }),
      }
    }
    case 'I00028': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          arcadeMachineId: notification.arcadeMachineId,
        }),
      }
    }
    case 'I00029': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          gameCenterId: notification.gameCenterId,
        }),
      }
    }
    case 'I00030': {
      return {
        title: t(`Notifications.${notification.messageId}`, {
          arcadeMachineId: notification.arcadeMachineId,
        }),
      }
    }
    default:
      const d: never = notification
      return { title: JSON.stringify(d) }
  }
}
